import { FunctionComponent } from 'react'
import { Navigate } from 'react-router'
import { ToastContainer } from 'react-toastify'

import environnement from '../../../infrastructure/config/environnement'
import { DASHBOARD_URL } from '../../../constants/navigation.constants'
import { useStore } from '../../../application/store/store'
import { useApiDocumentationHook } from './apiDocumentation.hook'
import { CopyButton } from './apiDocumentation.styles'

const ApiDocumentation: FunctionComponent = () => {
  const userAccessState = useStore((state) => state.user.access)
  const { copyAccessToken, t } = useApiDocumentationHook()

  return (
    <>
      {!userAccessState?.apiDocPage ? (
        <Navigate to={DASHBOARD_URL} />
      ) : (
        <>
          <CopyButton onClick={copyAccessToken}>{t('copy_access_token')}</CopyButton>
          <iframe width="100%" height="100%" title="doc" src={environnement.CLIENT_API_URL} />
        </>
      )}
      <ToastContainer />
    </>
  )
}

export default ApiDocumentation
